import { boolean, number, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ParameterType } from '../../../../whole-house/additional-parameter/parameter-type/Id';
import { ParameterRef } from '../../../../whole-house/additional-parameter/ParameterRef';

export const Request = struct({
	parameterRef: ParameterRef,
	defaultValue: union(number, boolean),
	label: iotsUtils.NotEmptyString,
	parameterType: ParameterType,
});
